import { PersonLeaveLimitSettingsService } from './Service/Person/PersonLeaveLimitSettings.service';
import { PersonLeaveLimitSettingsComponent } from './Component/Person/PersonLeaveLimitSettings/PersonLeaveLimitSettings.component';
import { DataEntityBalanceFormComponent } from './Component/DataEntity/DataEntityBalanceForm/DataEntityBalanceForm.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalibrationConfirmInvoiceComponent } from './Component/CalibrationConfirmInvoice/CalibrationConfirmInvoice.component';
import { CalibrationConfirmInvoiceFormComponent } from './Component/CalibrationConfirmInvoice/CalibrationConfirmInvoiceForm.component';
import { SalaryFishComponent } from './Component/Salary/SalaryFish/SalaryFish.component';
import { LetterrequestcustomerFactor2Component } from './Component/LetterrequestcustomerFactor2/LetterrequestcustomerFactor2.component';
import { LetterrequestcustomerFactor2FormComponent } from './Component/LetterrequestcustomerFactor2/LetterrequestcustomerFactor2Form.component';

import { CalibrationInPositionListComponent } from './Component/Calibration/CalibrationInPosition/CalibrationInPositionList/CalibrationInPositionList.component';
import { CalibrationReceptionListComponent } from './Component/Calibration/CalibrationReception/CalibrationReceptionList/CalibrationReceptionList.component';

import { CertificateFormComponent } from './Component/Certificate/CertificateForm/CertificateForm.component';
import { CertificateListComponent } from './Component/Certificate/CertificateList/CertificateList.component';
import { CertifivateDeliveryListComponent } from './Component/Certificate/CertifivateDelivery/CertifivateDeliveryList/CertifivateDeliveryList.component';
import { CertifivateDeliveryFormComponent } from './Component/Certificate/CertifivateDelivery/CertifivateDeliveryForm/CertifivateDeliveryForm.component';
import { CustomerAddComponent } from './Component/Cutomer/CustomerAdd/CustomerAdd.component';
import { CustomerEditComponent } from './Component/Cutomer/CustomerEdit/CustomerEdit.component';
import { CustomerListComponent } from './Component/Cutomer/CustomerList/CustomerList.component';


import { DashboardComponent } from './Component/Dashboard/Dashboard.component';
import { DeviceAddComponent } from './Component/Device/DeviceAdd/DeviceAdd.component';
import { DeviceEditComponent } from './Component/Device/DeviceEdit/DeviceEdit.component';
import { DeviceListComponent } from './Component/Device/DeviceList/DeviceList.component';
import { ErrorComponent } from './Component/Error/Error.component';
import { ExpertCalibrationAddComponent } from './Component/ExpertCalibration/ExpertCalibrationAdd/ExpertCalibrationAdd.component';
import { ExpertCalibrationEditComponent } from './Component/ExpertCalibration/ExpertCalibrationEdit/ExpertCalibrationEdit.component';
import { ExpertCalibrationListComponent } from './Component/ExpertCalibration/ExpertCalibrationList/ExpertCalibrationList.component';
import { ExpirationAddComponent } from './Component/Expiration/ExpirationAdd/ExpirationAdd.component';
import { ExpirationEditComponent } from './Component/Expiration/ExpirationEdit/ExpirationEdit.component';
import { ExpirationListComponent } from './Component/Expiration/ExpirationList/ExpirationList.component';
import { FeildActiviryAddComponent } from './Component/FieldActivity/FeildActiviryAdd/FeildActiviryAdd.component';
import { FeildActivityListComponent } from './Component/FieldActivity/FeildActivityList/FeildActivityList.component';
import { FieldActivityEditComponent } from './Component/FieldActivity/FieldActivityEdit/FieldActivityEdit.component';
import { LabDownloadUploadDeviceComponent } from './Component/Lab/LabDownloadUploadDevice/LabDownloadUploadDevice.component';
import { LoginComponent } from './Component/Login/Login.component';
import { AlertListComponent } from './Component/Alert/AlertList/AlertList.component';

import { UserAddComponent } from './Component/User/UserAdd/UserAdd.component';
import { UserEditComponent } from './Component/User/UserEdit/UserEdit.component';
import { UserListComponent } from './Component/User/UserList/UserList.component';
import { SematListComponent } from './Component/Semat/SematList/SematList.component';
import { SematAddComponent } from './Component/Semat/SematAdd/SematAdd.component';
import { SematEditComponent } from './Component/Semat/SematEdit/SematEdit.component';
import { SarFaslAmozeshiListComponent } from './Component/SarFaslAmozeshi/SarFaslAmozeshiList/SarFaslAmozeshiList.component';
import { SarFaslAmozeshiAddComponent } from './Component/SarFaslAmozeshi/SarFaslAmozeshiAdd/SarFaslAmozeshiAdd.component';
import { SarFaslAmozeshiEditComponent } from './Component/SarFaslAmozeshi/SarFaslAmozeshiEdit/SarFaslAmozeshiEdit.component';
import { DorehAmoozeshiListComponent } from './Component/DorehAmoozeshi/DorehAmoozeshiList/DorehAmoozeshiList.component';
import { DorehAmoozeshiAddComponent } from './Component/DorehAmoozeshi/DorehAmoozeshiAdd/DorehAmoozeshiAdd.component';
import { DorehAmoozeshiEditComponent } from './Component/DorehAmoozeshi/DorehAmoozeshiEdit/DorehAmoozeshiEdit.component';
import { SkillListComponent } from './Component/Skill/SkillList/SkillList.component';
import { SkillAddComponent } from './Component/Skill/SkillAdd/SkillAdd.component';
import { SkillEditComponent } from './Component/Skill/SkillEdit/SkillEdit.component';
import { DocumentGroupListComponent } from './Component/DocumentGroup/DocumentGroupList/DocumentGroupList.component';
import { DocumentGroupAddComponent } from './Component/DocumentGroup/DocumentGroupAdd/DocumentGroupAdd.component';
import { DocumentGroupEditComponent } from './Component/DocumentGroup/DocumentGroupEdit/DocumentGroupEdit.component';
import { DocumentTitleListComponent } from './Component/DocumentTitle/DocumentTitleList/DocumentTitleList.component';
import { DocumentTitleAddComponent } from './Component/DocumentTitle/DocumentTitleAdd/DocumentTitleAdd.component';
import { DocumentTitleEditComponent } from './Component/DocumentTitle/DocumentTitleEdit/DocumentTitleEdit.component';
import { PersonListComponent } from './Component/Person/PersonList/PersonList.component';
import { PersonAddComponent } from './Component/Person/PersonAdd/PersonAdd.component';
import { PersonEditComponent } from './Component/Person/PersonEdit/PersonEdit.component';
import { CertificateAsliComponent } from './Component/Certificate/CertificateAsli/CertificateAsli.component';
import { SMSTextListComponent } from './Component/SMSText/SMSTextList/SMSTextList.component';
import { SMSTextAddComponent } from './Component/SMSText/SMSTextAdd/SMSTextAdd.component';
import { SMSTextEditComponent } from './Component/SMSText/SMSTextEdit/SMSTextEdit.component';
import { SubjectLetterListComponent } from './Component/SubjectLetter/SubjectLetterList/SubjectLetterList.component';
import { SubjectLetterAddComponent } from './Component/SubjectLetter/SubjectLetterAdd/SubjectLetterAdd.component';
import { SubjectLetterEditComponent } from './Component/SubjectLetter/SubjectLetterEdit/SubjectLetterEdit.component';
import { DeviceGroupComponent } from './Component/DeviceGroup/DeviceGroup.component';
import { MailMessageListComponent } from './Component/MailMessage/MailMessageList/MailMessageList.component';
import { MailMessageAddComponent } from './Component/MailMessage/MailMessageAdd/MailMessageAdd.component';
import { MailMessageEditComponent } from './Component/MailMessage/MailMessageEdit/MailMessageEdit.component';
import { TextletterListComponent } from './Component/Textletter/TextletterList/TextletterList.component';
import { TextletterAddComponent } from './Component/Textletter/TextletterAdd/TextletterAdd.component';
import { TextletterEditComponent } from './Component/Textletter/TextletterEdit/TextletterEdit.component';
import { DeviceBehfaListComponent } from './Component/DeviceBehfa/DeviceBehfaList/DeviceBehfaList.component';
import { DeviceBehfaAddComponent } from './Component/DeviceBehfa/DeviceBehfaAdd/DeviceBehfaAdd.component';
import { DeviceBehfaEditComponent } from './Component/DeviceBehfa/DeviceBehfaEdit/DeviceBehfaEdit.component';
import { UnitListComponent } from './Component/Unit/UnitList/UnitList.component';
import { UnitAddComponent } from './Component/Unit/UnitAdd/UnitAdd.component';
import { UnitEditComponent } from './Component/Unit/UnitEdit/UnitEdit.component';
import { TariffListComponent } from './Component/Tariff/TariffList/TariffList.component';
import { TariffAddComponent } from './Component/Tariff/TariffAdd/TariffAdd.component';
import { TariffEditComponent } from './Component/Tariff/TariffEdit/TariffEdit.component';
import { DeviceBehfaDownloadUploadComponent } from './Component/DeviceBehfa/DeviceBehfaDownloadUpload/DeviceBehfaDownloadUpload.component';
import { DeviceBehfaGozareshKarkardComponent } from './Component/DeviceBehfa/DeviceBehfaGozareshKarkard/DeviceBehfaGozareshKarkard.component';
import { QUANTITYComponent } from './Component/QUANTITY/QUANTITY.component';
import { DeviceBehfaConfirmUploadedComponent } from './Component/DeviceBehfa/DeviceBehfaConfirmUploaded/DeviceBehfaConfirmUploaded.component';
import { DefinitionscertificateAddComponent } from './Component/Definitionscertificate/DefinitionscertificateAdd/DefinitionscertificateAdd.component';
import { DefinitionscertificateListComponent } from './Component/Definitionscertificate/DefinitionscertificateList/DefinitionscertificateList.component';
import { DevicepersianListComponent } from './Component/Devicepersian/DevicepersianList/DevicepersianList.component';
import { DevicepersianAddComponent } from './Component/Devicepersian/DevicepersianAdd/DevicepersianAdd.component';
import { DevicepersianEditComponent } from './Component/Devicepersian/DevicepersianEdit/DevicepersianEdit.component';
import { LetterRequestCustomerComponent } from './Component/Letter/LetterRequestCustomer/LetterRequestCustomer.component';
import { LetterRequestCustomerFormComponent } from './Component/Letter/LetterRequestCustomerForm/LetterRequestCustomerForm.component';
import { LabCalibrationComponent } from './Component/Lab/LabCalibration/LabCalibration.component';
import { DataEntity01Component } from './Component/DataEntity/DataEntity01/DataEntity01.component';
import { LabConfirmCalibrationComponent } from './Component/Lab/LabConfirmCalibration/LabConfirmCalibration.component';
import { LabCertificateComponent } from './Component/Lab/LabCertificate/LabCertificate.component';
import { LetterRequestCustomerDraftFormComponent } from './Component/Letter/LetterRequestCustomerDraftForm/LetterRequestCustomerDraftForm.component';
import { LetterRequestCustomerPreOrderComponent } from './Component/Letter/LetterRequestCustomerPreOrder/LetterRequestCustomerPreOrder.component';
import { CutomeruserformComponent } from './Component/Cutomer/Cutomeruserform/Cutomeruserform.component';
import { RepresentativeListComponent } from './Component/Representative/RepresentativeList/RepresentativeList.component';
import { RepresentativeAddComponent } from './Component/Representative/RepresentativeAdd/RepresentativeAdd.component';
import { RepresentativeEditComponent } from './Component/Representative/RepresentativeEdit/RepresentativeEdit.component';
import { TicketListComponent } from './Component/Ticket/TicketList/TicketList.component';
import { TicketFormComponent } from './Component/Ticket/TicketForm/TicketForm.component';
import { TicketReplyComponent } from './Component/Ticket/TicketReply/TicketReply.component';
import { TicketAdminFormComponent } from './Component/Ticket/TicketAdminForm/TicketAdminForm.component';
import { BehfaRoleAddComponent } from './Component/BehfaRole/BehfaRoleAdd/BehfaRoleAdd.component';
import { BehfaRoleEditComponent } from './Component/BehfaRole/BehfaRoleEdit/BehfaRoleEdit.component';
import { BehfaRoleListComponent } from './Component/BehfaRole/BehfaRoleList/BehfaRoleList.component';
import { BehfaRoleListAdminComponent } from './Component/BehfaRole/BehfaRoleListAdmin/BehfaRoleListAdmin.component';
import { LetterRequestCustomerCalibrationComponent } from './Component/Letter/LetterRequestCustomerCalibration/LetterRequestCustomerCalibration.component';
import { LetterRequestCustomerCalibrationListComponent } from './Component/Letter/LetterRequestCustomerCalibrationList/LetterRequestCustomerCalibrationList.component';
import { BehfaListAdminComponent } from './Component/Behfa/BehfaListAdmin/BehfaListAdmin.component';
import { BehfaListComponent } from './Component/Behfa/BehfaList/BehfaList.component';
import { TicketCategoryListComponent } from './Component/Ticket/TicketCategory/TicketCategoryList/TicketCategoryList.component';
import { TicketCategoryAddComponent } from './Component/Ticket/TicketCategory/TicketCategoryAdd/TicketCategoryAdd.component';
import { TicketCategoryEditComponent } from './Component/Ticket/TicketCategory/TicketCategoryEdit/TicketCategoryEdit.component';
import { LetterRequestCustomerPreOrderListComponent } from './Component/Letter/LetterRequestCustomerPreOrderList/LetterRequestCustomerPreOrderList.component';
import { LetterRequestCustomerDeviceListComponent } from './Component/Letter/LetterRequestCustomerDeviceList/LetterRequestCustomerDeviceList.component';
import { LetterRequestCustomerDeviceComponent } from './Component/Letter/LetterRequestCustomerDevice/LetterRequestCustomerDevice.component';
import { LabDownloadDeviceFormComponent } from './Component/Lab/LabDownloadDeviceForm/LabDownloadDeviceForm.component';
import { LabUploadDeviceFormComponent } from './Component/Lab/LabUploadDeviceForm/LabUploadDeviceForm.component';
import { DeviceBehfaDownloadFormComponent } from './Component/DeviceBehfa/DeviceBehfaDownloadForm/DeviceBehfaDownloadForm.component';
import { DeviceBehfaUploadFormComponent } from './Component/DeviceBehfa/DeviceBehfaUploadForm/DeviceBehfaUploadForm.component';
import { CutomerInfoComponent } from './Component/Cutomer/CutomerInfo/CutomerInfo.component';
import { ContractorListComponent } from './Component/Contractor/ContractorList/ContractorList.component';
import { ContractorAddComponent } from './Component/Contractor/ContractorAdd/ContractorAdd.component';
import { ContractorEditComponent } from './Component/Contractor/ContractorEdit/ContractorEdit.component';
import { ContractorCustomerComponent } from './Component/Contractor/ContractorCustomer/ContractorCustomer.component';
import { CutomerCommentComponent } from './Component/Cutomer/CutomerComment/CutomerComment.component';
import { CutomerCommentCheckComponent } from './Component/Cutomer/CutomerCommentCheck/CutomerCommentCheck.component';
import { AddressTitleListComponent } from './Component/AddressTitle/AddressTitleList/AddressTitleList.component';
import { AddressTitleAddComponent } from './Component/AddressTitle/AddressTitleAdd/AddressTitleAdd.component';
import { AddressTitleEditComponent } from './Component/AddressTitle/AddressTitleEdit/AddressTitleEdit.component';
import { LetterRequestCustomerScheduleComponent } from './Component/Letter/LetterRequestCustomerSchedule/LetterRequestCustomerSchedule.component';
import { CalendarListComponent } from './Component/Calendar/CalendarList/CalendarList.component';
import { CalendarFormComponent } from './Component/Calendar/CalendarForm/CalendarForm.component';
import { MoneyListComponent } from './Component/Money/MoneyList/MoneyList.component';
import { MoneyAddComponent } from './Component/Money/MoneyAdd/MoneyAdd.component';
import { MoneyEditComponent } from './Component/Money/MoneyEdit/MoneyEdit.component';
import { LetterRequestCustomerScheduleCancelComponent } from './Component/Letter/LetterRequestCustomerScheduleCancel/LetterRequestCustomerScheduleCancel.component';
import { DeviceBehfaRepairComponent } from './Component/DeviceBehfa/DeviceBehfaRepair/DeviceBehfaRepair.component';
import { HelpListComponent } from './Component/Help/HelpList/HelpList.component';
import { LetterRequestCustomerInboxComponent } from './Component/Letter/LetterRequestCustomerInbox/LetterRequestCustomerInbox.component';
import { LetterRequestCustomerDeviceBehfaComponent } from './Component/Letter/LetterRequestCustomerDeviceBehfa/LetterRequestCustomerDeviceBehfa.component';
import { TariffHistoryComponent } from './Component/Tariff/TariffHistory/TariffHistory.component';
import { KartableInboxComponent } from './Component/Kartable/KartableInbox/KartableInbox.component';
import { PersonEdit1Component } from './Component/Person/PersonEdit1/PersonEdit1.component';
import { PersonList1Component } from './Component/Person/PersonList1/PersonList1.component';
import { LetterRequestCustomerFormCustomerComponent } from './Component/Letter/LetterRequestCustomerFormCustomer/LetterRequestCustomerFormCustomer.component';
import { LetterRequestCustomerScheduleCustomerComponent } from './Component/Letter/LetterRequestCustomerScheduleCustomer/LetterRequestCustomerScheduleCustomer.component';
import { UserhistoryComponent } from './Component/User/Userhistory/Userhistory.component';
import { LetterRequestCustomerScheduleSentenceComponent } from './Component/Letter/LetterRequestCustomerScheduleSentence/LetterRequestCustomerScheduleSentence.component';
import { CustomerListUserComponent } from './Component/Cutomer/CustomerListUser/CustomerListUser.component';
import { CalibrationDeliveryListComponent } from './Component/CalibrationDelivery/CalibrationDeliveryList/CalibrationDeliveryList.component';
import { ColleagueDownloadComponent } from './Component/Colleague/ColleagueDownload/ColleagueDownload.component';
import { ColleagueListComponent } from './Component/Colleague/ColleagueList/ColleagueList.component';
import { DataEntity02Component } from './Component/DataEntity/DataEntity02/DataEntity02.component';
import { CertificateFormListComponent } from './Component/CertificateForm/CertificateFormList/CertificateFormList.component';
import { FundsListComponent } from './Component/Funds/FundsList/FundsList.component';
import { FundsUserComponent } from './Component/Funds/FundsUser/FundsUser.component';
import { FundsReviewComponent } from './Component/Funds/FundsReview/FundsReview.component';
import { LabExitReviewComponent } from './Component/Lab/LabExitReview/LabExitReview.component';
import { CabinetListComponent } from './Component/Cabinet/CabinetList/CabinetList.component';
import { FundsTitleListComponent } from './Component/Funds/FundsTitleList/FundsTitleList.component';
import { CabinetViewComponent } from './Component/Cabinet/CabinetView/CabinetView.component';
import { CalibrationEvaluateListComponent } from './Component/Calibration/CalibrationEvaluate/CalibrationEvaluateList/CalibrationEvaluateList.component';
import { PMItemListComponent } from './Component/PM/PMItemList/PMItemList.component';
import { PMProgramListComponent } from './Component/PM/PMProgramList/PMProgramList.component';
import { PMDurationListComponent } from './Component/PM/PMDurationList/PMDurationList.component';
import { IconComponent } from './Component/Icon/Icon.component';
import { PMServiceListComponent } from './Component/PM/PMServiceList/PMServiceList.component';
import { PMSubmitListComponent } from './Component/PM/PMSubmitList/PMSubmitList.component';
import { UserUrlComponent } from './Component/User/UserUrl/UserUrl.component';
import { LetterRequestCustomerScheduleDeviceBehfaComponent } from './Component/Letter/LetterRequestCustomerScheduleDeviceBehfa/LetterRequestCustomerScheduleDeviceBehfa.component';
import { SMSHistoryComponent } from './Component/SMS/SMSHistory/SMSHistory.component';
import { DataEntity02_01Component } from './Component/DataEntity/DataEntity02_01/DataEntity02_01.component';
import { KartableControllerComponent } from './Component/Kartable/KartableController/KartableController.component';
import { DataEntity03Component } from './Component/DataEntity/DataEntity03/DataEntity03.component';
import { FundsSettleComponent } from './Component/Funds/FundsSettle/FundsSettle.component';
import { FundsWithdrawComponent } from './Component/Funds/FundsWithdraw/FundsWithdraw.component';
import { Protocol17025CatComponent } from './Component/Protocol17025/Protocol17025Cat/Protocol17025Cat.component';
import { Protocol17025ChartComponent } from './Component/Protocol17025/Protocol17025Chart/Protocol17025Chart.component';
import { DataEntity03_01Component } from './Component/DataEntity/DataEntity03_01/DataEntity03_01.component';
import { LetterRequestCustomerReviewFormListComponent } from './Component/Letter/LetterRequestCustomerReviewFoorm/LetterRequestCustomerReviewFormList/LetterRequestCustomerReviewFormList.component';
import { Protocol17025ViewComponent } from './Component/Protocol17025/Protocol17025View/Protocol17025View.component';
import { KartableControllerReviewComponent } from './Component/Kartable/KartableControllerReview/KartableControllerReview.component';
import { KartableDevicePointComponent } from './Component/Kartable/KartableDevicePoint/KartableDevicePoint.component';
import { DataEntity03_02Component } from './Component/DataEntity/DataEntity03_02/DataEntity03_02.component';
import { DeviceInLetterComponent } from './Component/Device/DeviceInLetter/DeviceInLetter.component';
import { SuggestTitleListComponent } from './Component/Suggest/SuggestTitle/SuggestTitleList/SuggestTitleList.component';
import { SuggestTitleAddComponent } from './Component/Suggest/SuggestTitle/SuggestTitleAdd/SuggestTitleAdd.component';
import { SuggestTitleEditComponent } from './Component/Suggest/SuggestTitle/SuggestTitleEdit/SuggestTitleEdit.component';
import { SuggestListComponent } from './Component/Suggest/SuggestMain/SuggestList/SuggestList.component';
import { KartableDevicePoint2Component } from './Component/Kartable/KartableDevicePoint2/KartableDevicePoint2.component';
import { DeviceConditionFormComponent } from './Component/DeviceCondition/DeviceConditionForm/DeviceConditionForm.component';
import { DeviceConditionListComponent } from './Component/DeviceCondition/DeviceConditionList/DeviceConditionList.component';
import { KartableCertificateComponent } from './Component/Kartable/KartableCertificate/KartableCertificate.component';
import { ChartComponent } from './Component/Chart/Chart/Chart.component';
import { FlowchartMainComponent } from './Component/Flowchart/FlowchartMain/FlowchartMain.component';
import { FlowchartWorkflowComponent } from './Component/Flowchart/FlowchartWorkflow/FlowchartWorkflow.component';
import { PersonOffDayListComponent } from './Component/Person/PersonOffDay/PersonOffDayList/PersonOffDayList.component';
import { PersonOffDayAddComponent } from './Component/Person/PersonOffDay/PersonOffDayAdd/PersonOffDayAdd.component';
import { FlowchartFormComponent } from './Component/Flowchart/FlowchartForm/FlowchartForm.component';
import { FlowchartInboxComponent } from './Component/Flowchart/FlowchartInbox/FlowchartInbox.component';
import { FlowchartArchiveComponent } from './Component/Flowchart/FlowchartArchive/FlowchartArchive.component';
import { SuggestReportComponent } from './Component/Suggest/SuggestMain/SuggestReport/SuggestReport.component';
import { DataEntity04Component } from './Component/DataEntity/DataEntity04/DataEntity04.component';
import { DataEntity05Component } from './Component/DataEntity/DataEntity05/DataEntity05.component';
import { DataEntity06Component } from './Component/DataEntity/DataEntity06/DataEntity06.component';
import { DataEntity07Component } from './Component/DataEntity/DataEntity07/DataEntity07.component';
import { ProductGroupAddComponent } from './Component/ProductGroup/ProductGroupAdd/ProductGroupAdd.component';
import { ProductGroupEditComponent } from './Component/ProductGroup/ProductGroupEdit/ProductGroupEdit.component';
import { ProductGroupListComponent } from './Component/ProductGroup/ProductGroupList/ProductGroupList.component';
import { ProductAddComponent } from './Component/Product/ProductAdd/ProductAdd.component';
import { ProductEditComponent } from './Component/Product/ProductEdit/ProductEdit.component';
import { ProductListComponent } from './Component/Product/ProductList/ProductList.component';
import { ProductRequestListComponent } from './Component/ProductRequest/ProductRequestList/ProductRequestList.component';
import { ProductRequestAddComponent } from './Component/ProductRequest/ProductRequestAdd/ProductRequestAdd.component';
import { PersonOffTimeAddComponent } from './Component/Person/PersonOffTime/PersonOffTimeAdd/PersonOffTimeAdd.component';
import { PersonOffTimeListComponent } from './Component/Person/PersonOffTime/PersonOffTimeList/PersonOffTimeList.component';
import { DataEntity08Component } from './Component/DataEntity/DataEntity08/DataEntity08.component';
import { DataEntity09Component } from './Component/DataEntity/DataEntity09/DataEntity09.component';
import { DataEntity10Component } from './Component/DataEntity/DataEntity10/DataEntity10.component';
import { CertificateNoteListComponent } from './Component/CertificateNote/CertificateNoteList/CertificateNoteList.component';
import { CertificateNoteAddComponent } from './Component/CertificateNote/CertificateNoteAdd/CertificateNoteAdd.component';
import { UserErrorComponent } from './Component/User/UserError/UserError.component';
import { DeviceBehfaRefComponent } from './Component/DeviceBehfa/DeviceBehfaRef/DeviceBehfaRef.component';
import { DataEntity11Component } from './Component/DataEntity/DataEntity11/DataEntity11.component';
import { RoleListComponent } from './Component/Role/RoleList/RoleList.component';
import { KartableCustomerReportComponent } from './Component/Kartable/KartableCustomerReport/KartableCustomerReport.component';
import { ScheduleLetterListComponent } from './Component/Schedule/ScheduleLetter/ScheduleLetterList/ScheduleLetterList.component';
import { ScheduleLetterModirListComponent } from './Component/Schedule/ScheduleLetterModir/ScheduleLetterModirList/ScheduleLetterModirList.component';
import { DataEntity11_01Component } from './Component/DataEntity/DataEntity11_01/DataEntity11_01.component';
import { DataEntityVolumeFormComponent } from './Component/DataEntity/DataEntityVolumeForm/DataEntityVolumeForm.component';
import { DataEntityThermometerFormComponent } from './Component/DataEntity/DataEntityThermometerForm/DataEntityThermometerForm.component';
import { DataEntityMassFormComponent } from './Component/DataEntity/DataEntityMassForm/DataEntityMassForm.component';
import { TariffFloorComponent } from './Component/Tariff/TariffFloor/TariffFloor.component';
import { AzmoonMaharatMainListComponent } from './Component/AzmoonMaharat/AzmoonMaharatMain/AzmoonMaharatMainList/AzmoonMaharatMainList.component';
import { AzmoonMaharatRequestCalenderComponent } from './Component/AzmoonMaharat/AzmoonMaharatRequest/AzmoonMaharatRequestCalender/AzmoonMaharatRequestCalender.component';
import { AzmoonMaharatMainSignInListComponent } from './Component/AzmoonMaharat/AzmoonMaharatMainSignIn/AzmoonMaharatMainSignInList/AzmoonMaharatMainSignInList.component';
import { AzmoonMaharatRequestListComponent } from './Component/AzmoonMaharat/AzmoonMaharatRequest/AzmoonMaharatRequestList/AzmoonMaharatRequestList.component';
import { AzmoonMaharatMainConfirmComponent } from './Component/AzmoonMaharat/AzmoonMaharatMainSignIn/AzmoonMaharatMainConfirm/AzmoonMaharatMainConfirm.component';
import { DeviceBehfaFilterGroupListComponent } from './Component/DeviceBehfaFilterGroup/DeviceBehfaFilterGroupList/DeviceBehfaFilterGroupList.component';
import { LetterrequestcustomerRelativeListComponent } from './Component/LetterrequestcustomerRelative/LetterrequestcustomerRelativeList/LetterrequestcustomerRelativeList.component';
import { LetterrequestcustomerIgnoreComponent } from './Component/Letter/LetterrequestcustomerIgnore/LetterrequestcustomerIgnore.component';
import { SalaryListComponent } from './Component/Salary/SalaryList/SalaryList.component';
import { SalaryEzafeKarComponent } from './Component/Salary/SalaryEzafeKar/SalaryEzafeKar.component';
import { DeviceBehfaPerformanceComponent } from './Component/DeviceBehfa/DeviceBehfaPerformance/DeviceBehfaPerformance.component';
import { SalaryMonthListComponent } from './Component/Salary/SalaryMonthList/SalaryMonthList.component';
import { SalaryDayListComponent } from './Component/Salary/SalaryDayList/SalaryDayList.component';
import { LetterRequestCustomerReportComponent } from './Component/Letter/LetterRequestCustomerReport/LetterRequestCustomerReport.component';
import { SalarySanavatListComponent } from './Component/Salary/SalarySanavatList/SalarySanavatList.component';
import { KartableBarchasbComponent } from './Component/Kartable/KartableBarchasb/KartableBarchasb.component';




import { PM_V2_TemplateListComponent } from './Component/PM_V2/PM_V2_TemplateList/PM_V2_TemplateList.component';
import { PM_V2_TemplateAddComponent } from './Component/PM_V2/PM_V2_TemplateAdd/PM_V2_TemplateAdd.component';
import { PM_V2_TemplateEditComponent } from './Component/PM_V2/PM_V2_TemplateEdit/PM_V2_TemplateEdit.component';
import { PM_V2_AssignmentListComponent } from './Component/PM_V2/PM_V2_AssignmentList/PM_V2_AssignmentList.component';
import { PM_V2_AssignmentAddComponent } from './Component/PM_V2/PM_V2_AssignmentAdd/PM_V2_AssignmentAdd.component';
import { PM_V2_AssignmentDetailComponent } from './Component/PM_V2/PM_V2_AssignmentDetail/PM_V2_AssignmentDetail.component';
import { PM_V2_DueListComponent } from './Component/PM_V2/PM_V2_DueList/PM_V2_DueList.component';
import { PM_V2_DueEquipmentDetailComponent } from './Component/PM_V2/PM_V2_DueEquipmentDetail/PM_V2_DueEquipmentDetail.component';
import { PM_V2_ExecutionAddComponent } from './Component/PM_V2/PM_V2_ExecutionAdd/PM_V2_ExecutionAdd.component';
import { PM_V2_ExecutionHistoryComponent } from './Component/PM_V2/PM_V2_ExecutionHistory/PM_V2_ExecutionHistory.component';
import { ICTemplateListComponent } from './Component/IC/ICTemplateList/ICTemplateList.component';
import { ICTemplateAddComponent } from './Component/IC/ICTemplateAdd/ICTemplateAdd.component';
import { ICTemplateEditComponent } from './Component/IC/ICTemplateEdit/ICTemplateEdit.component';
import { ICAssignmentListComponent } from './Component/IC/ICAssignmentList/ICAssignmentList.component';
import { ICAssignmentAddComponent } from './Component/IC/ICAssignmentAdd/ICAssignmentAdd.component';
import { ICAssignmentDetailComponent } from './Component/IC/ICAssignmentDetail/ICAssignmentDetail.component';
import { ICDueListComponent } from './Component/IC/ICDueList/ICDueList.component';
import { ICExecutionAddComponent } from './Component/IC/ICExecutionAdd/ICExecutionAdd.component';
import { ICExecutionHistoryComponent } from './Component/IC/ICExecutionHistory/ICExecutionHistory.component';
import { ICDashboardComponent } from './Component/IC/ICDashboard/ICDashboard.component';
import { ICTrendComponent } from './Component/IC/ICTrend/ICTrend.component';

const routes: Routes = [
  { path: 'PersonLeaveLimitSettings', component: PersonLeaveLimitSettingsComponent, canActivate: [PersonLeaveLimitSettingsService] },
  { path: 'Dashboard', component: DashboardComponent },

  { path: 'Customer', component: CustomerListComponent },
  { path: 'CustomerAdd', component: CustomerAddComponent },
  { path: 'CustomerEdit', component: CustomerEditComponent },
  { path: 'Cutomeruserform', component: CutomeruserformComponent },
  { path: 'CustomerInfo', component: CutomerInfoComponent },
  { path: 'CutomerComment', component: CutomerCommentComponent },
  { path: 'CustomerListUser', component: CustomerListUserComponent },
  { path: 'CutomerCommentCheck', component: CutomerCommentCheckComponent },

  { path: 'FeildActivity', component: FeildActivityListComponent },
  { path: 'FeildActivityAdd', component: FeildActiviryAddComponent },
  { path: 'FeildActivityEdit', component: FieldActivityEditComponent },

  { path: 'Contractor', component: ContractorListComponent },
  { path: 'ContractorAdd', component: ContractorAddComponent },
  { path: 'ContractorEdit', component: ContractorEditComponent },
  { path: 'ContractorCustomer', component: ContractorCustomerComponent },

  { path: 'DeviceConditionForm', component: DeviceConditionFormComponent },
  { path: 'DeviceCondition', component: DeviceConditionListComponent },

  { path: 'Device', component: DeviceListComponent },
  { path: 'DeviceAdd', component: DeviceAddComponent },
  { path: 'DeviceEdit', component: DeviceEditComponent },
  { path: 'DeviceInLetter', component: DeviceInLetterComponent },

  { path: 'Alert', component: AlertListComponent },

  { path: 'User', component: UserListComponent },
  { path: 'UserAdd', component: UserAddComponent },
  { path: 'UserEdit', component: UserEditComponent },
  { path: 'Userhistory', component: UserhistoryComponent },
  { path: 'UserUrl', component: UserUrlComponent },
  { path: 'UserError', component: UserErrorComponent },

  { path: 'Expiration', component: ExpirationListComponent },
  { path: 'ExpirationAdd', component: ExpirationAddComponent },
  { path: 'ExpirationEdit', component: ExpirationEditComponent },

  { path: 'Funds', component: FundsListComponent },
  { path: 'FundsUser', component: FundsUserComponent },
  { path: 'FundsReview', component: FundsReviewComponent },
  { path: 'FundsTitle', component: FundsTitleListComponent },
  { path: 'FundsSettle', component: FundsSettleComponent },
  { path: 'FundsWithdraw', component: FundsWithdrawComponent },

  { path: 'Semat', component: SematListComponent },
  { path: 'SematAdd', component: SematAddComponent },
  { path: 'SematEdit', component: SematEditComponent },

  { path: 'Person', component: PersonListComponent },
  { path: 'Person1', component: PersonList1Component },
  { path: 'PersonAdd', component: PersonAddComponent },
  { path: 'PersonEdit', component: PersonEditComponent },
  { path: 'PersonEdit1', component: PersonEdit1Component },

  { path: 'DocumentTitle', component: DocumentTitleListComponent },
  { path: 'DocumentTitleAdd', component: DocumentTitleAddComponent },
  { path: 'DocumentTitleEdit', component: DocumentTitleEditComponent },

  { path: 'DocumentGroup', component: DocumentGroupListComponent },
  { path: 'DocumentGroupAdd', component: DocumentGroupAddComponent },
  { path: 'DocumentGroupEdit', component: DocumentGroupEditComponent },

  { path: 'Tariff', component: TariffListComponent },
  { path: 'TariffAdd', component: TariffAddComponent },
  { path: 'TariffEdit', component: TariffEditComponent },
  { path: 'TariffHistory', component: TariffHistoryComponent },
  { path: 'TariffFloor', component: TariffFloorComponent },

  { path: 'Skill', component: SkillListComponent },
  { path: 'SkillAdd', component: SkillAddComponent },
  { path: 'SkillEdit', component: SkillEditComponent },

  { path: 'Suggest', component: SuggestListComponent },
  { path: 'SuggestReport', component: SuggestReportComponent },

  { path: 'SuggestTitle', component: SuggestTitleListComponent },
  { path: 'SuggestTitleAdd', component: SuggestTitleAddComponent },
  { path: 'SuggestTitleEdit', component: SuggestTitleEditComponent },

  { path: 'Cabinet', component: CabinetListComponent },
  { path: 'CabinetView', component: CabinetViewComponent },

  { path: 'Money', component: MoneyListComponent },
  { path: 'MoneyAdd', component: MoneyAddComponent },
  { path: 'MoneyEdit', component: MoneyEditComponent },

  { path: 'Unit', component: UnitListComponent },
  { path: 'UnitAdd', component: UnitAddComponent },
  { path: 'UnitEdit', component: UnitEditComponent },

  { path: 'DeviceBehfa', component: DeviceBehfaListComponent },
  { path: 'DeviceBehfaAdd', component: DeviceBehfaAddComponent },
  { path: 'DeviceBehfaDownloadForm', component: DeviceBehfaDownloadFormComponent },
  { path: 'DeviceBehfaUploadForm', component: DeviceBehfaUploadFormComponent },
  { path: 'DeviceBehfaEdit', component: DeviceBehfaEditComponent },
  { path: 'DeviceBehfaDownloadUpload', component: DeviceBehfaDownloadUploadComponent },
  { path: 'DeviceBehfaGozareshKarkard', component: DeviceBehfaGozareshKarkardComponent },
  { path: 'DeviceBehfaConfirmUploaded', component: DeviceBehfaConfirmUploadedComponent },
  { path: 'DeviceBehfaRepair', component: DeviceBehfaRepairComponent },
  { path: 'DeviceBehfaRef', component: DeviceBehfaRefComponent },
  { path: 'DeviceBehfaPerformance', component: DeviceBehfaPerformanceComponent },

  { path: 'Textletter', component: TextletterListComponent },
  { path: 'TextletterAdd', component: TextletterAddComponent },
  { path: 'TextletterEdit', component: TextletterEditComponent },

  { path: 'Help', component: HelpListComponent },

  { path: 'CalibrationDelivery', component: CalibrationDeliveryListComponent },
  { path: 'CalibrationEvaluate', component: CalibrationEvaluateListComponent },

  { path: 'AddressTitle', component: AddressTitleListComponent },
  { path: 'AddressTitleAdd', component: AddressTitleAddComponent },
  { path: 'AddressTitleEdit', component: AddressTitleEditComponent },

  { path: 'SubjectLetter', component: SubjectLetterListComponent },
  { path: 'SubjectLetterAdd', component: SubjectLetterAddComponent },
  { path: 'SubjectLetterEdit', component: SubjectLetterEditComponent },
  
  { path: 'Flowchart', component: FlowchartMainComponent },
  { path: 'FlowchartWorkflow', component: FlowchartWorkflowComponent },
  { path: 'FlowchartForm', component: FlowchartFormComponent },
  { path: 'FlowchartInbox', component: FlowchartInboxComponent },
  { path: 'FlowchartArchive', component: FlowchartArchiveComponent },
  
  { path: 'Offday', component: PersonOffDayListComponent },
  { path: 'OffdayForm', component: PersonOffDayAddComponent },

  { path: 'SMSText', component: SMSTextListComponent },
  { path: 'SMSTextAdd', component: SMSTextAddComponent },
  { path: 'SMSTextEdit', component: SMSTextEditComponent },

  { path: 'MailMessage', component: MailMessageListComponent },
  { path: 'MailMessageAdd', component: MailMessageAddComponent },
  { path: 'MailMessageEdit', component: MailMessageEditComponent },

  { path: 'DorehAmoozeshi', component: DorehAmoozeshiListComponent },
  { path: 'DorehAmoozeshiAdd', component: DorehAmoozeshiAddComponent },
  { path: 'DorehAmoozeshiEdit', component: DorehAmoozeshiEditComponent },

  { path: 'SarFaslAmozeshi', component: SarFaslAmozeshiListComponent },
  { path: 'SarFaslAmozeshiAdd', component: SarFaslAmozeshiAddComponent },
  { path: 'SarFaslAmozeshiEdit', component: SarFaslAmozeshiEditComponent },


  //{ path: 'CalibrationInPosition', component: CalibrationInPositionListComponent },

  { path: 'DevicepersianAdd', component: DevicepersianAddComponent },
  { path: 'DevicepersianEdit', component: DevicepersianEditComponent },
  { path: 'Devicepersian', component: DevicepersianListComponent },

  { path: 'CalibrationReception', component: CalibrationReceptionListComponent },

  { path: 'Definitionscertificate', component: DefinitionscertificateListComponent },
  { path: 'DefinitionscertificateAdd', component: DefinitionscertificateAddComponent },

  { path: 'CertificateForm', component: CertificateFormComponent },
  { path: 'CertificateList', component: CertificateListComponent },
  { path: 'CertificateAsli', component: CertificateAsliComponent },
  { path: 'CertifivateDelivery', component: CertifivateDeliveryListComponent },
  { path: 'CertifivateDeliveryForm', component: CertifivateDeliveryFormComponent },

  { path: 'LabDownloadUploadDevice', component: LabDownloadUploadDeviceComponent },
  { path: 'LabDownloadDeviceForm', component: LabDownloadDeviceFormComponent },
  { path: 'LabUploadDeviceForm', component: LabUploadDeviceFormComponent },
  { path: 'LabCertificate', component: LabCertificateComponent },
  { path: 'LabConfirmCalibration', component: LabConfirmCalibrationComponent },
  { path: 'LabCalibration', component: LabCalibrationComponent },
  { path: 'LabExitReview', component: LabExitReviewComponent },

  { path: 'DeviceGroup', component: DeviceGroupComponent },
  { path: 'Quantity', component: QUANTITYComponent },
  { path: 'Login', component: LoginComponent },


  { path: 'LetterRequestCustomer', component: LetterRequestCustomerComponent },
  { path: 'LetterRequestCustomerForm', component: LetterRequestCustomerFormComponent },
  { path: 'LetterRequestCustomerDraftForm', component: LetterRequestCustomerDraftFormComponent },
  { path: 'LetterRequestCustomerPreOrder', component: LetterRequestCustomerPreOrderComponent },
  { path: 'LetterRequestCustomerPreOrderList', component: LetterRequestCustomerPreOrderListComponent },
  { path: 'LetterRequestCustomerDevice', component: LetterRequestCustomerDeviceComponent },
  { path: 'LetterRequestCustomerDeviceList', component: LetterRequestCustomerDeviceListComponent },
  { path: 'LetterRequestCustomerCalibration', component: LetterRequestCustomerCalibrationComponent },
  { path: 'LetterRequestCustomerCalibrationList', component: LetterRequestCustomerCalibrationListComponent },
  { path: 'LetterRequestCustomerSchedule', component: LetterRequestCustomerScheduleComponent },
  { path: 'LetterRequestCustomerScheduleCancel', component: LetterRequestCustomerScheduleCancelComponent },
  { path: 'LetterRequestCustomerInbox', component: LetterRequestCustomerInboxComponent },
  { path: 'LetterRequestCustomerDeviceBehfa', component: LetterRequestCustomerDeviceBehfaComponent },
  { path: 'LetterRequestCustomerFormCustomer', component: LetterRequestCustomerFormCustomerComponent },
  { path: 'LetterRequestCustomerScheduleCustomer', component: LetterRequestCustomerScheduleCustomerComponent },
  { path: 'LetterRequestCustomerScheduleSentence', component: LetterRequestCustomerScheduleSentenceComponent },
  { path: 'LetterRequestCustomerScheduleDeviceBehfa', component: LetterRequestCustomerScheduleDeviceBehfaComponent },
  { path: 'LetterRequestCustomerReview', component: LetterRequestCustomerReviewFormListComponent },
  { path: 'LetterRequestCustomerReport', component: LetterRequestCustomerReportComponent },

  { path: 'DataEntity01', component: DataEntity01Component },
  
  { path: 'DataEntity02', component: DataEntity02Component },
  { path: 'dataEntity02', component: DataEntity02Component },

  { path: 'DataEntity02_01', component: DataEntity02_01Component },
  { path: 'dataEntity02_01', component: DataEntity02_01Component },

  { path: 'DataEntity03', component: DataEntity03Component },
  { path: 'dataEntity03', component: DataEntity03Component },

  { path: 'DataEntity03_01', component: DataEntity03_01Component },
  { path: 'dataEntity03_01', component: DataEntity03_01Component },

  { path: 'DataEntity03_02', component: DataEntity03_02Component },
  { path: 'dataEntity03_02', component: DataEntity03_02Component },

  { path: 'DataEntity04', component: DataEntity04Component },
  { path: 'dataEntity04', component: DataEntity04Component },

  { path: 'DataEntity05', component: DataEntity05Component },
  { path: 'dataEntity05', component: DataEntity05Component },

  { path: 'DataEntity06', component: DataEntity06Component },
  { path: 'dataEntity06', component: DataEntity06Component },
  
  { path: 'DataEntity07', component: DataEntity07Component },
  { path: 'dataEntity07', component: DataEntity07Component },
  
  { path: 'DataEntity08', component: DataEntity08Component },
  { path: 'dataEntity08', component: DataEntity08Component },

  { path: 'DataEntity09', component: DataEntity09Component },
  { path: 'dataEntity09', component: DataEntity09Component },

  { path: 'DataEntity10', component: DataEntity10Component },
  { path: 'dataEntity10', component: DataEntity10Component },

  { path: 'DataEntity11', component: DataEntity11Component },
  { path: 'dataEntity11', component: DataEntity11Component },

  { path: 'DataEntity11_01', component: DataEntity11_01Component },
  { path: 'dataEntity11_01', component: DataEntity11_01Component },
  { path: 'DataEntityVolumeForm', component: DataEntityVolumeFormComponent },
  { path: 'DataEntityThermometerForm', component: DataEntityThermometerFormComponent },
  { path: 'DataEntityBalanceForm', component: DataEntityBalanceFormComponent },
  { path: 'DataEntityBalanceForm/:id', component: DataEntityBalanceFormComponent },
  { path: 'DataEntityThermometerForm/:id', component: DataEntityThermometerFormComponent },
  { path: 'DataEntityMassForm', component: DataEntityMassFormComponent },
  { path: 'DataEntityMassForm/:id', component: DataEntityMassFormComponent },

  { path: 'RepresentativeAdd', component: RepresentativeAddComponent },
  { path: 'RepresentativeEdit', component: RepresentativeEditComponent },
  { path: 'Representative', component: RepresentativeListComponent },
  
  { path: 'ProductRequestForm', component: ProductRequestAddComponent },
  { path: 'ProductRequest', component: ProductRequestListComponent },

  { path: 'OffTimeForm', component: PersonOffTimeAddComponent },
  { path: 'OffTime', component: PersonOffTimeListComponent },

  { path: 'ProductGroupAdd', component: ProductGroupAddComponent },
  { path: 'ProductGroupEdit', component: ProductGroupEditComponent },
  { path: 'ProductGroup', component: ProductGroupListComponent },

  { path: 'ProductAdd', component: ProductAddComponent },
  { path: 'ProductEdit', component: ProductEditComponent },
  { path: 'Product', component: ProductListComponent },

  { path: 'Ticket', component: TicketListComponent },
  { path: 'TicketForm', component: TicketFormComponent },
  { path: 'TicketReply', component: TicketReplyComponent },
  { path: 'TicketAdminForm', component: TicketAdminFormComponent },

  { path: 'BehfaRuleAdd', component: BehfaRoleAddComponent },
  { path: 'BehfaRuleEdit', component: BehfaRoleEditComponent },
  { path: 'BehfaRule', component: BehfaRoleListComponent },
  { path: 'BehfaRuleAdmin', component: BehfaRoleListAdminComponent },

  { path: 'BehfaListAdmin', component: BehfaListAdminComponent },
  { path: 'Behfa', component: BehfaListComponent },

  { path: 'TicketCategory', component: TicketCategoryListComponent },
  { path: 'TicketCategoryAdd', component: TicketCategoryAddComponent },
  { path: 'TicketCategoryEdit', component: TicketCategoryEditComponent },

  { path: 'Calendar', component: CalendarListComponent },
  { path: 'CalendarForm', component: CalendarFormComponent },
  
  { path: 'Role', component: RoleListComponent },

  { path: 'KartableInbox', component: KartableInboxComponent },
  { path: 'KartableController', component: KartableControllerComponent },
  { path: 'KartableControllerReview', component: KartableControllerReviewComponent },
  { path: 'KartableDevicePoint', component: KartableDevicePointComponent },
  { path: 'KartableDevicePoint2', component: KartableDevicePoint2Component },
  { path: 'KartableCertificate', component: KartableCertificateComponent },
  { path: 'KartableCustomerReport', component: KartableCustomerReportComponent },

  { path: 'SMS', component: SMSHistoryComponent },
  { path: 'Chart', component: ChartComponent },

  { path: 'ScheduleLetterList', component: ScheduleLetterListComponent },
  { path: 'ScheduleLetterModirList', component: ScheduleLetterModirListComponent },

  { path: 'ColleagueDownload', component: ColleagueDownloadComponent },
  { path: 'Colleague', component: ColleagueListComponent },

  { path: 'CertificateFormList', component: CertificateFormListComponent },

  { path: 'PMItem', component: PMItemListComponent },
  { path: 'PMProgram', component: PMProgramListComponent },
  { path: 'PMDuration', component: PMDurationListComponent },
  { path: 'PMService', component: PMServiceListComponent },
  { path: 'PMSubmit', component: PMSubmitListComponent },

  { path: 'Icon', component: IconComponent },

  { path: 'Protocol17025Cat', component: Protocol17025CatComponent },
  { path: 'Protocol17025Chart', component: Protocol17025ChartComponent },
  { path: 'Protocol17025View', component: Protocol17025ViewComponent },
  
  { path: 'CertificateNoteAdd', component: CertificateNoteAddComponent },
  { path: 'CertificateNote', component: CertificateNoteListComponent },
  
  { path: 'AzmoonMaharatMain', component: AzmoonMaharatMainListComponent },
  { path: 'AzmoonMaharatRequestCalendar', component: AzmoonMaharatRequestCalenderComponent },
  { path: 'AzmoonMaharatMainSignIn', component: AzmoonMaharatMainSignInListComponent },
  { path: 'AzmoonMaharatRequest', component: AzmoonMaharatRequestListComponent },
  { path: 'AzmoonMaharatMainConfirm', component: AzmoonMaharatMainConfirmComponent },
  { path: 'DeviceBehfaFilterGroup', component: DeviceBehfaFilterGroupListComponent },
  { path: 'LetterrequestcustomerRelative', component: LetterrequestcustomerRelativeListComponent },
  { path: 'LetterrequestcustomerIgnore', component: LetterrequestcustomerIgnoreComponent },
  
  { path: 'Salary', component: SalaryListComponent },
  { path: 'SalaryEzafeKar', component: SalaryEzafeKarComponent },
  { path: 'SalaryMonth', component: SalaryMonthListComponent },
  { path: 'SalaryFish', component: SalaryFishComponent },
  { path: 'SalaryDay', component: SalaryDayListComponent },
  { path: 'SalarySanavat', component: SalarySanavatListComponent },
  
  { path: 'KartableBarchasb', component: KartableBarchasbComponent },
  { path: 'CalibrationConfirmInvoice', component: CalibrationConfirmInvoiceComponent },
  { path: 'CalibrationConfirmInvoiceForm', component: CalibrationConfirmInvoiceFormComponent },
  { path: 'LetterrequestcustomerFactor', component: LetterrequestcustomerFactor2Component },
  { path: 'LetterrequestcustomerFactorForm', component: LetterrequestcustomerFactor2FormComponent },

  { path: 'pm-v2/template', component: PM_V2_TemplateListComponent },
  { path: 'pm-v2/template/add', component: PM_V2_TemplateAddComponent },
  { path: 'pm-v2/template/edit/:id', component: PM_V2_TemplateEditComponent },
  { path: 'pm-v2/assignment', component: PM_V2_AssignmentListComponent },
  { path: 'pm-v2/assignment/add', component: PM_V2_AssignmentAddComponent },
  { path: 'pm-v2/assignment/detail/:id', component: PM_V2_AssignmentDetailComponent },
  { path: 'pm-v2/due', component: PM_V2_DueListComponent },
  { path: 'pm-v2/due/equipment/:equipmentId', component: PM_V2_DueEquipmentDetailComponent },
  { path: 'pm-v2/execution/add/:id', component: PM_V2_ExecutionAddComponent },
  { path: 'pm-v2/execution/history/:id', component: PM_V2_ExecutionHistoryComponent },
  
  { path: 'ic/template', component: ICTemplateListComponent },
  { path: 'ic/template/add', component: ICTemplateAddComponent },
  { path: 'ic/template/edit/:id', component: ICTemplateEditComponent },
  { path: 'ic/assignment', component: ICAssignmentListComponent },
  { path: 'ic/assignment/add', component: ICAssignmentAddComponent },
  { path: 'ic/assignment/detail/:id', component: ICAssignmentDetailComponent },
  { path: 'ic/due', component: ICDueListComponent },
  { path: 'ic/execution/add/:id', component: ICExecutionAddComponent },
  { path: 'ic/history', component: ICExecutionHistoryComponent },
  { path: 'ic/execution/history/:id', component: ICExecutionHistoryComponent },
  { path: 'ic/dashboard', component: ICDashboardComponent },
  { path: 'ic/trend/:equipmentId/:itemId', component: ICTrendComponent },

  { path: '',   redirectTo: '/Dashboard', pathMatch: 'full' },
  { path: '**', component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],

})
export class AppRoutingModule { }
